import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksByIdOptions, getOrgPlaybooksByPlaybookIdVersionsByVersionIdOptions, getOrgPlaybooksByPlaybookIdVersionsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';
export const SELECTED_VERSION_QUERY_KEY = 'version';
const usePlaybook = playbookId => {
  const $ = _c(33);
  let t0;
  if ($[0] !== playbookId) {
    t0 = getOrgPlaybooksByIdOptions({
      path: {
        id: playbookId
      }
    });
    $[0] = playbookId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getPlaybook = useQuery(t0);
  let t1;
  if ($[2] !== playbookId) {
    t1 = getOrgPlaybooksByPlaybookIdVersionsOptions({
      path: {
        playbookId
      },
      query: {
        pageSize: 100
      }
    });
    $[2] = playbookId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getPlaybookVersions = useQuery(t1);
  const [version, setVersion] = useQueryState(SELECTED_VERSION_QUERY_KEY);
  let playbookVersions;
  let selectedVersionNoGraph;
  let t2;
  let t3;
  if ($[4] !== getPlaybookVersions.data?.data || $[5] !== playbookId || $[6] !== version) {
    playbookVersions = getPlaybookVersions.data?.data || [];
    let t4;
    if ($[11] !== version) {
      t4 = playbookVersion => playbookVersion.id === version;
      $[11] = version;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    selectedVersionNoGraph = playbookVersions.find(t4);
    t3 = useQuery;
    t2 = getOrgPlaybooksByPlaybookIdVersionsByVersionIdOptions({
      path: {
        playbookId,
        versionId: selectedVersionNoGraph?.id || ""
      }
    });
    $[4] = getPlaybookVersions.data?.data;
    $[5] = playbookId;
    $[6] = version;
    $[7] = playbookVersions;
    $[8] = selectedVersionNoGraph;
    $[9] = t2;
    $[10] = t3;
  } else {
    playbookVersions = $[7];
    selectedVersionNoGraph = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  const t4 = !!selectedVersionNoGraph?.id;
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = {
      ...t2,
      enabled: t4
    };
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const getPlaybookVersionDetail = t3(t5);
  let t6;
  let t7;
  if ($[16] !== playbookVersions || $[17] !== setVersion || $[18] !== version) {
    t6 = () => {
      const selectedVersion = playbookVersions.find(playbookVersion_0 => playbookVersion_0.id === version);
      if (!selectedVersion && playbookVersions.length > 0) {
        const firstVersion = playbookVersions[0];
        setVersion(firstVersion.id);
      }
    };
    t7 = [version, playbookVersions, setVersion];
    $[16] = playbookVersions;
    $[17] = setVersion;
    $[18] = version;
    $[19] = t6;
    $[20] = t7;
  } else {
    t6 = $[19];
    t7 = $[20];
  }
  useEffect(t6, t7);
  let t8;
  if ($[21] !== getPlaybook || $[22] !== getPlaybookVersions) {
    t8 = async () => {
      const [, playbookVersions_0] = await Promise.all([getPlaybook.refetch(), getPlaybookVersions.refetch()]);
      return playbookVersions_0;
    };
    $[21] = getPlaybook;
    $[22] = getPlaybookVersions;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const refetch = t8;
  const t9 = getPlaybook.isPending || getPlaybookVersions.isPending;
  const t10 = getPlaybook.error || getPlaybookVersions.error;
  let t11;
  if ($[24] !== getPlaybook.data || $[25] !== getPlaybookVersionDetail.data || $[26] !== playbookVersions || $[27] !== refetch || $[28] !== selectedVersionNoGraph || $[29] !== setVersion || $[30] !== t10 || $[31] !== t9) {
    t11 = {
      playbook: getPlaybook.data,
      selectedVersionNoGraph,
      selectedVersion: getPlaybookVersionDetail.data,
      setVersion,
      playbookVersions,
      isPending: t9,
      error: t10,
      refetch
    };
    $[24] = getPlaybook.data;
    $[25] = getPlaybookVersionDetail.data;
    $[26] = playbookVersions;
    $[27] = refetch;
    $[28] = selectedVersionNoGraph;
    $[29] = setVersion;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default usePlaybook;